const merchantLayoutRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: { user: ['Administrator', 'Merchant'] }
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import('@/views/dashboard/merchant/Accounts.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/beneficiaries',
    name: 'Beneficiaries',
    component: () => import('@/views/dashboard/merchant/Beneficiaries.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/payment-authorization',
    name: 'Payment Authorization',
    component: () => import('@/views/dashboard/merchant/PaymentAuthorization.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/fund-disbursement',
    name: 'Fund Disbursement',
    component: () => import('@/views/dashboard/merchant/fund_disbursement/FundDisbursement.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/approve-fund-disbursement',
    name: 'Merchant Fund Disbursement Approval',
    component: () => import('@/views/dashboard/merchant/fund_disbursement/FundDisbursementApproval.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('@/views/dashboard/merchant/Reports.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/repost-transactions/merchant-transactions',
    name: 'Merchant Transactions',
    component: () => import('@/views/dashboard/merchant/repost_transactions/MerchantTransactions.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/repost-transactions/transaction-repost-approval',
    name: 'Merchant Transaction Repost Approval',
    component: () => import('@/views/dashboard/merchant/repost_transactions/TransactionRepostApproval.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/merchant-audit-trail',
    name: 'Merchant Audit Trail',
    component: () => import('@/views/dashboard/merchant/AuditTrail.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/users/all-merchant-users',
    name: 'All Merchant Users',
    component: () => import('@/views/dashboard/merchant/users/AllMerchantUsers.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/users/merchant-user-registration',
    name: 'Merchant User Registration',
    component: () => import('@/views/dashboard/merchant/users/MerchantUserRegistration.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/users/assign-merchant-user-operation',
    name: 'Assign Merchant User Operation',
    component: () => import('@/views/dashboard/merchant/users/AssignUserOperation.vue'),
    meta: { user: 'Merchant' }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/dashboard/merchant/Settings.vue'),
    meta: { user: 'Merchant' }
  }
]

export default merchantLayoutRoutes
